export enum ClientTypeEnum {
    Individual = "INDIVIDUAL",
    SoleTrader = "SOLE_TRADER",
    Company = "COMPANY",
    // HousingAssociation = "HOUSING_ASSOCIATION",
    LeasingLessor = "LEASING_LESSOR",
    Bank = "BANK",
}